import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Colors } from '../classes/colors'
import { Icons } from '../classes/icons'
import { ButtonTypes } from '../classes/button-types'
import { EasyModalService } from '../services/easy-modal.service'
import { EasyNotification } from '../notificationService/notification.service'
import { EasyField } from '../baseClasses/easyField';
import { HttpIntegrationService } from 'easy-core';
import { Subscription } from 'rxjs/Subscription';
import { EasyContainer } from '../baseClasses/easyContainer';
import { EasyForm } from '../baseClasses/easyForm'

@Injectable()
export class EasyFormService implements OnDestroy {

  private form: EasyForm;
  private errorSubscription: Subscription;
  private easyModal: EasyModalService;
  private modal: EasyContainer;
  private stackTraceField: EasyField;

  constructor(private easyNotification: EasyNotification, private httpIntegrationService: HttpIntegrationService, matDialog: MatDialog) {

    this.easyModal = new EasyModalService(matDialog);

    this.errorSubscription = httpIntegrationService.OnError.subscribe(x => {
      if (x.status == 0) {
        this.easyNotification.showError("Error", "No response from server.", () => this.showErrorModal(x.json().Message));
      }
      else if (x.status == 500) {
        this.easyNotification.showError("Error", x.status + " : " + x.statusText, () => this.showErrorModal(x.json().Message));
      }
    });
  }

  buildModal() {
    this.modal = this.form.addModalContainer("Error");
    this.stackTraceField = this.modal.addTextAreaField("Stack Trace", { readonly: true });
    this.modal.addAction('Back', () => { }, { key: 'Back', color: Colors.color_warn, icon: Icons.icon_arrow_back, showLoader: true, type: ButtonTypes.button_raised, columnSpan: 2 });
  }

  showErrorModal(message: string) {
    this.stackTraceField.value = message;
    this.easyModal.showModal(this.modal);
  }

  createForm() {
    this.form = new EasyForm();
    this.buildModal();
    return this.form;
  }

  ngOnDestroy() {
    this.errorSubscription.unsubscribe();
  }
}
